(function () {
  const PDPcanvas = document.getElementById("product-canvas");
  const PDPctx = PDPcanvas ? PDPcanvas.getContext("2d") : null;
  const imageContainer0 = document.querySelector(".product-container");
  const scrollTriggerElement = document.querySelector(".scroll-content");

  let frameCount = 0;
  let images = [];

  /** Utility: keep only valid (non-empty) frame URLs */
  function getValidFrames(frames) {
    return Array.isArray(frames) ? frames.filter(Boolean) : [];
  }

  /**
   * Utility: hide the fallback <img> cleanly.
   * Removing the src attribute (instead of leaving it empty/undefined) means the
   * browser renders NOTHING instead of the broken-image icon.
   */
  function hideRotatingImage(rotatingImage) {
    const img =
      rotatingImage || document.querySelector("img.product-featured_image");
    if (!img) return;
    img.removeAttribute("src");
    img.style.visibility = "hidden";
  }

  /** Utility: put the PDP into a clean "no animation" state for variants without frames */
  function enterNoAnimationState() {
    hideRotatingImage();

    if (PDPcanvas) {
      if (PDPctx) PDPctx.clearRect(0, 0, PDPcanvas.width, PDPcanvas.height);
      PDPcanvas.style.visibility = "hidden";
    }

    imageContainer0?.classList.remove("animated-ready");
    document.body.classList.remove("js-canvas-animation-ready");
    document.body.classList.remove("canvas-loading");
    // CSS/Liquid hook: use this class to show a static fallback product image if you have one
    document.body.classList.add("no-product-animation");

    try {
      const existing = ScrollTrigger.getById("productScroll");
      if (existing) existing.kill();
    } catch (e) {}
  }

  /** Utility: leave the "no animation" state when a variant WITH frames is selected */
  function exitNoAnimationState() {
    document.body.classList.remove("no-product-animation");
    if (PDPcanvas) PDPcanvas.style.visibility = "visible";
  }

  /** Utility: Preload Images */
  function preloadImages(urls, callback) {
    const list = getValidFrames(urls);

    // No frames for this variant → don't hang, just return an empty set
    if (list.length === 0) {
      callback([]);
      return;
    }

    const loaded = [];
    let count = 0;
    const done = () => {
      count++;
      if (count === list.length) callback(loaded);
    };

    list.forEach((url, i) => {
      const img = new Image();
      img.onload = done;
      img.onerror = done; // one broken frame must not stall the whole preload
      img.src = url;
      loaded[i] = img;
    });
  }

  /** Utility: Draw Image to Canvas with Aspect Ratio */
  function drawImageToCanvas(img) {
    if (!img || !PDPctx || !PDPcanvas) return;

    const imgRatio = img.width / img.height;
    const canvasRatio = PDPcanvas.width / PDPcanvas.height;

    let drawWidth, drawHeight;
    if (imgRatio > canvasRatio) {
      drawWidth = PDPcanvas.width;
      drawHeight = drawWidth / imgRatio;
    } else {
      drawHeight = PDPcanvas.height;
      drawWidth = drawHeight * imgRatio;
    }

    const x = (PDPcanvas.width - drawWidth) / 2;
    const y = (PDPcanvas.height - drawHeight) / 2;

    PDPctx.clearRect(0, 0, PDPcanvas.width, PDPcanvas.height);
    PDPctx.drawImage(img, x, y, drawWidth, drawHeight);
  }

  /** Draw Frame from Index */
  function drawFrame(index) {
    const img = images[index];
    if (img?.complete && img.naturalWidth > 0) {
      drawImageToCanvas(img);
    } else {
      console.warn(`Frame ${index} not loaded yet.`);
    }
  }

  /** Setup GSAP ScrollTrigger */
  function initializeScrollTrigger() {
    if (window.innerWidth <= 768) return;
    // Nothing to scrub if this variant has no frames
    if (frameCount < 1 || images.length === 0) return;

    const scene = { frame: 0 };
    const existing = ScrollTrigger.getById("productScroll");
    if (existing) existing.kill();

    gsap.registerPlugin(ScrollTrigger);

    if (window.theme.is_rtd_template) {
      // Benefit animations
      gsap.utils.toArray(".benefits-items .benefit-details").forEach((item) => {
        gsap.fromTo(
          item,
          { opacity: 0, y: 50 },
          {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: "power3.out",
            scrollTrigger: {
              trigger: item,
              start: "top 85%",
              toggleActions: "play none none none",
            },
          }
        );
      });

      gsap.timeline({
        id: "productScroll",
        scrollTrigger: {
          trigger: scrollTriggerElement,
          // start: "top-=250px top",
          // end: "bottom+=1000px bottom",
          start: "top top",
          end: "bottom bottom",
          scrub: 1,
        },
      }).to(scene, {
        frame: frameCount - 1,
        ease: "none",
        snap: "frame",
        onUpdate: () => {
          const frameIndex = Math.max(0, Math.floor(scene.frame));
          drawFrame(frameIndex);
        },
      });

      // Box image scroll logic
      const imgEl = document.querySelector(".box-wrapper img");
      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger:
            "body.product-rtd-pdp .product.grid>.product-benefits-wrapper .benefits-items:last-child",
          start: "top 100%",
          end: "top 50%",
          scrub: true,
          onEnterBack: () => {
            if (imgEl) imgEl.src = window.theme.rtd_open_box_image;
          },
        },
      });

      const rightValue =
        window.innerWidth <= 1536 && window.innerWidth > 768 ? "52%" : "50%";

      timeline.to(".close-box-img", { right: rightValue, ease: "none" });
      timeline.add(() => {
        if (imgEl) imgEl.src = window.theme.rtd_close_box_image;
      });
    } else {
      setTimeout(() => {
        gsap.timeline({
          id: "productScroll",
          scrollTrigger: {
            trigger: scrollTriggerElement,
            start: "top top",
            end: "bottom+=250px bottom",
            scrub: 1,
          },
        }).to(scene, {
          frame: frameCount - 1,
          ease: "none",
          snap: "frame",
          onUpdate: () => {
            drawFrame(Math.max(0, Math.floor(scene.frame)));
          },
        });
      }, 350);
    }
  }

  /** Handle Mobile Swipe */
  function initializeMobileSwipe(imageUrls) {
    const frames = getValidFrames(imageUrls);
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!isMobile || frames.length === 0) return;

    const rotatingImage = document.querySelector("img.product-featured_image");
    if (!rotatingImage) return;

    rotatingImage.src = frames[0];

    let currentFrame = 0;
    let isDragging = false;
    let startX = 0;
    let accumulatedDeltaX = 0;
    const pixelsPerFrame = 12;

    // Gesture hint (guarded so it never indexes past the available frames)
    function showDragGesture() {
      let frame = 0;
      const maxFrames = Math.min(15, frames.length - 1);
      if (maxFrames < 1) return;

      const forward = setInterval(() => {
        if (frame < maxFrames && frames[frame + 1]) {
          rotatingImage.src = frames[++frame];
        } else {
          clearInterval(forward);
          reverseGesture(frame);
        }
      }, 50);
      window.mobileGestureInterval = forward;
    }

    function reverseGesture(start) {
      let frame = start;
      const reverse = setInterval(() => {
        if (frame >= 0 && frames[frame]) {
          rotatingImage.src = frames[frame--];
        } else {
          clearInterval(reverse);
          rotatingImage.src = frames[0];
        }
      }, 50);
      window.mobileGestureInterval = reverse;
    }

    setTimeout(showDragGesture, 250);

    // Swipe handling
    function handleSwipe(pageX) {
      const deltaX = pageX - startX;
      accumulatedDeltaX += deltaX;
      startX = pageX;

      const frameChange = Math.floor(accumulatedDeltaX / pixelsPerFrame);
      if (frameChange !== 0) {
        accumulatedDeltaX = 0;
        currentFrame =
          (currentFrame - frameChange + frames.length) % frames.length;
        rotatingImage.src = frames[currentFrame];
      }
    }

    rotatingImage.addEventListener("touchstart", (e) => {
      isDragging = true;
      startX = e.touches[0].pageX;
      accumulatedDeltaX = 0;
    });

    rotatingImage.addEventListener("touchmove", (e) => {
      if (isDragging) handleSwipe(e.touches[0].pageX);
    });

    rotatingImage.addEventListener("touchend", () => {
      isDragging = false;
    });
  }

  /** Setup Frames for Selected Variant */
  function setVariantFrames(variantId = null) {
    const selected = variantFrames.find(
      (v) => v.selected || v.variant === variantId
    );

    if (!selected) return console.warn("No valid variant found.");

    const frames = getValidFrames(selected.frames);

    // ✅ No animation frames uploaded for this variant → skip animation,
    //    hide the <img> so no broken-image tag shows up.
    if (frames.length === 0) {
      window.theme.product_animation_frames = [];
      frameCount = 0;
      images = [];
      enterNoAnimationState();
      return;
    }

    exitNoAnimationState();
    window.theme.product_animation_frames = frames;
    frameCount = frames.length;

    preloadImages(frames, (loaded) => {
      images = loaded;
      drawFrame(0);
      initializeScrollTrigger();
      imageContainer0.classList.add("animated-ready");
      document.body.classList.add("js-canvas-animation-ready");
      initializeMobileSwipe(frames);
    });

    const rotatingImage = document.querySelector("img.product-featured_image");
    if (rotatingImage && frames.length > 0) {
      rotatingImage.style.visibility = "visible";
      rotatingImage.src = frames[0];
    }
  }

  /** Variant Change Handler */
  function onVariantChangeCustom(event) {
    const variantId = event.detail?.id;
    const variantData = variantFrames.find((v) => v.variant === variantId);
    const imageContainer = document.querySelector(".product-container");
    const rotatingImage = document.querySelector("img.product-featured_image");

    if (!variantData || !rotatingImage) return;

    // ✅ STOP OLD MOBILE GESTURE
    if (window.mobileGestureInterval) {
      clearInterval(window.mobileGestureInterval);
      window.mobileGestureInterval = null;
    }

    const frames = getValidFrames(variantData.frames);

    // ✅ Selected variant has NO frames → clean no-animation state, no broken image.
    if (frames.length === 0) {
      window.theme.product_animation_frames = [];
      frameCount = 0;
      images = [];
      enterNoAnimationState();
      return;
    }

    exitNoAnimationState();

    // ✅ HIDE canvas + image during transition
    PDPcanvas.style.visibility = "hidden";
    rotatingImage.style.visibility = "hidden";
    document.body.classList.add("canvas-loading");
    imageContainer.classList.remove("animated-ready");
    document.body.classList.remove("js-canvas-animation-ready");

    // ✅ Update global state
    window.theme.product_animation_frames = frames;
    frameCount = frames.length;

    // ✅ Preload all frames
    preloadImages(frames, (loaded) => {
      images = loaded;
      const firstImage = loaded[0];

      // ✅ Safety: if nothing usable loaded, fall back to no-animation state
      if (!firstImage) {
        enterNoAnimationState();
        return;
      }

      // ✅ Wait for first image to load
      const finalize = () => {
        // ✅ Draw to canvas
        drawImageToCanvas(firstImage);
        drawFrame(0);

        // ✅ Set mobile image
        rotatingImage.src = frames[0];

        // ✅ Show image + canvas
        PDPcanvas.style.visibility = "visible";
        rotatingImage.style.visibility = "visible";

        // ✅ Run gesture only if enough frames
        if (
          frames.length >= 10 &&
          /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
        ) {
          initializeMobileSwipe(frames);
        }

        // ✅ Re-init ScrollTrigger on desktop
        if (window.innerWidth > 768) {
          initializeScrollTrigger();
        }

        // ✅ Final UI cleanup
        document.body.classList.remove("canvas-loading");
        imageContainer.classList.add("animated-ready");
        document.body.classList.add("js-canvas-animation-ready");
      };

      if (!firstImage.complete) {
        firstImage.onload = finalize;
        firstImage.onerror = () => enterNoAnimationState();
      } else {
        finalize();
      }
    });
  }

  // ✅ Defensive catch-all: if the fallback <img> ever gets a bad src, hide it
  //    instead of letting the browser show the broken-image icon.
  const rotatingImageEl = document.querySelector("img.product-featured_image");
  if (rotatingImageEl) {
    rotatingImageEl.addEventListener("error", () =>
      hideRotatingImage(rotatingImageEl)
    );
  }

  /** Init on Load */
  if (PDPcanvas) {
    setVariantFrames(); // Initial call
  }

  document.addEventListener("myCustomEvent", onVariantChangeCustom);
})();